import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { AnalyticsEvent, AnalyticsService } from '../../../core/services/analytics-service';
import { DialogService } from '../../../core/services/dialog.service';
import { OFFER_DIALOG_MAX_WIDTH, OFFER_DIALOG_WIDTH } from '../../../shared/configs/dialog-config';
import { DobryPradOfferDialogComponent } from '../dobry-prad-offer-dialog/dobry-prad-offer-dialog.component';

@Component({
standalone: false,
  selector: 'app-dobry-prad-welcome-dialog',
  styleUrls: ['./dobry-prad-welcome-dialog.component.scss'],
  templateUrl: './dobry-prad-welcome-dialog.component.html',
})
export class DobryPradWelcomeDialogComponent {
  constructor(
    private dialogRef: MatDialogRef<DobryPradWelcomeDialogComponent>,
    private dialogService: DialogService,
    private analyticsService: AnalyticsService,
  ) {}

  public showOffer(): void {
    this.analyticsService.trackEvent(new AnalyticsEvent('Dobry Prad offer shown from welcome dialog'));
    this.dialogRef.close();

    this.dialogService.open(DobryPradOfferDialogComponent, {
      maxWidth: OFFER_DIALOG_MAX_WIDTH,
      width: OFFER_DIALOG_WIDTH,
    });
  }
}
